import { stateList } from './constant';

// Form Constant Value
export const formConstant = {
  FULL_NAME: 'fullName',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL_ADDRESS: 'email',
  ADDRESS: 'address',
  PIN_CODE: 'pinCode',
  CITY: 'city',
  STATE: 'state',
  ZONE: 'zone',
};

export const formConfig = (t, franchiseSelectedOption) => {
  return {
    inputs: [
      {
        name: formConstant.FULL_NAME,
        placeholder: t('app.FULL_NAME'),
        customStyle: 'customInputStyle1',
        validations: {
          required: true,
          minLength: 3,
          maxLength: 50,
        },
        type: 'text',
      },
      {
        name: formConstant.PHONE_NUMBER,
        placeholder: t('app.PHONE_NUMBER'),
        customStyle: 'customInputStyle2',
        validations: {
          required: true,
          pattern: /^[0-9]{10}$/g,
          custom: (value) => {
            const isRepetitive = /^(\d)\1{9}$/.test(value);
            if (isRepetitive) {
              return 'Invalid Phone Number';
            }
            return '';
          },
        },
        type: 'tel',
      },
      {
        name: formConstant.EMAIL_ADDRESS,
        placeholder: t('app.EMAIL_ID'),
        customStyle: 'customInputStyle3',
        validations: {
          required: true,
          pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/g,
          maxLength: 50,
        },
        type: 'text',
      },
      {
        name: formConstant.ADDRESS,
        placeholder: t('app.ADDRESS'),
        customStyle: 'customInputStyle4',
        validations: {
          required: true,
          minLength: 3,
          maxLength: 250,
        },
        type: 'text',
      },
      {
        name: formConstant.PIN_CODE,
        placeholder: t('app.PIN_CODE'),
        customStyle: 'customInputStyle5',
        validations: {
          required:
            franchiseSelectedOption === 'courier_booking' ? false : true,
          custom: (value) => {
            if (!value) return ''; // No error if empty
            const pinCodes = value.split(',').map((pin) => pin.trim());
            if (franchiseSelectedOption === 'courier_booking') {
              const invalidLengthPinCodes = pinCodes.filter(
                (pin) => pin && !/^\d{6}$/.test(pin)
              );
              return invalidLengthPinCodes.length > 0
                ? t('app.INVALID_PIN_CODE_LENGTH')
                : '';
            } else {
              const invalidLengthPinCodes = pinCodes?.filter(
                (pin) => pin && !/^\d{6}$/.test(pin)
              );
              if (invalidLengthPinCodes.length > 0) {
                return t('app.INVALID_PIN_CODE_LENGTH');
              }
              const invalidPinCodes = pinCodes?.filter(
                (pin) => pin && !pincodes?.availablePinCodes?.includes(pin)
              );
              return invalidPinCodes?.length > 0
                ? `${invalidPinCodes?.join(', ')} ${t('app.NOT_SERVICEABLE')}`
                : '';
            }
          },
        },
        type: 'text',
      },
      {
        name: formConstant.CITY,
        placeholder: t('app.CITY'),
        customStyle: 'customInputStyle6',
        validations: {
          required: true,
          pattern: /^[A-Za-z\s]+$/,
          minLength: 2,
          maxLength: 15,
        },
        type: 'text',
      },
      {
        name: formConstant.STATE,
        placeholder: t('app.STATE'),
        customStyle: 'customInputStyle7',
        validations: {
          required: true,
        },
        type: 'dropdown',
        options: stateList,
      },
    ],
  };
};
// REGEX Constant
export const regex = {
  REMOVE_WHITE_SPACE: /\s{2,}/g,
  NUMBER: /[^0-9]/g,
};
